import React from "react"

/**
 * The readable text of a column title, for surfaces that need a string.
 *
 * A title may be a node — a label with an explanation beside it, say — and
 * `String()` on one yields "[object Object]".
 */
export const columnLabelText = (title: unknown, fallback: string): string => {
  if (typeof title === "string") return title
  if (typeof title === "number") return String(title)

  if (React.isValidElement(title)) {
    const props = title.props as {
      field?: string
      children?: React.ReactNode
    }
    if (props.field) return props.field

    const text = React.Children.toArray(props.children)
      .map((child) => columnLabelText(child, ""))
      .find(Boolean)

    if (text) return text
  }

  return fallback
}
